import {
  Component,
  ElementRef,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { fromEvent, Subscription } from 'rxjs';
import { ICurrentParams } from '../../models/catalog.models';
import { ObjectUtils } from '../../utils/object.utils';

@Component({
  selector: 'app-sort-by',
  templateUrl: './sort-by.component.html',
  styleUrls: ['./sort-by.component.scss'],
  standalone: false,
})
export class SortByComponent implements OnInit, OnChanges, OnDestroy {
  @Input() sort!: Array<any>;
  @Input() params!: ICurrentParams;
  @Input() current: any;
  @Input() cssClass!: string;
  @Input() hasTitle: boolean = true;
  @Input() isCatalogPage: boolean = false;
  @Output() selected: EventEmitter<any> = new EventEmitter<any>();

  active: any;
  isOpen: boolean = false;
  private documentClickSubscription!: Subscription;
  private readonly select: ElementRef = inject(ElementRef);
  private readonly router: Router = inject(Router);

  ngOnInit(): void {
    this.active = this.params || this.current;

    // Use fromEvent to listen for clicks outside the component
    this.documentClickSubscription = fromEvent<MouseEvent>(document, 'mousedown').subscribe((event: MouseEvent) => {
      if (!this.select.nativeElement.contains(event.target)) {
        this.isOpen = false;
      }
    });
  }

  ngOnChanges(): void {
    this.active = this.params || this.current;
  }

  ngOnDestroy(): void {
    // Unsubscribe from the observable to prevent memory leaks
    if (this.documentClickSubscription) {
      this.documentClickSubscription.unsubscribe();
      this.documentClickSubscription = undefined!;
    }
  }

  showTitle(): boolean {
    if (this.hasTitle) {
      return !(this.isCatalogPage && this.isActive());
    } else {
      return false;
    }
  }

  showOptions(): void {
    this.isOpen = !this.isOpen;
  }

  isActive(): boolean {
    if (this.current) {
      return this.sort.find(sort => ObjectUtils.isEqual(sort, this.active));
    }
    return this.sort.find(sort => sort.value === this.active.sort);
  }

  isSelected(option: string): boolean {
    const selectedOption: string = this.active.sort ?? this.active.name;

    return option === selectedOption;
  }

  activeSortLabel(): string {
    let activeSort: any;

    if (this.current) {
      activeSort = this.sort.find(sort => ObjectUtils.isEqual(sort, this.active));
    } else {
      activeSort = this.sort.find(sort => sort.value === this.active.sort);
    }

    return activeSort ? activeSort.name : '';
  }

  pageUrl(): string {
    return decodeURIComponent(this.router.url.split('?')[0]);
  }

  queryParams(option: any): any {
    const urlTree: UrlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams.sort = option.value;
    return urlTree.queryParams;
  }

  selectSort(option: any): any {
    this.active = option;

    this.selected.emit(this.current ? option : option.value);
  }
}
